<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import 'assets/stylesheets/lib/html5doctor';
#app {
  font-family: 'Noto Sans JP', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue